import { CircularProgress } from '@material-ui/core';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import React, { useEffect, useState } from 'react';
import useStyles from '../modules/Licenses/components/DetailsDialog/DetailsDialog.styles';

interface DialogWarningSaveInterface {
    message: string;
    isLoading: boolean;
    operation?: () => void;
    onClose: () => void;
    positiveResponseText?: string;
    negativeResponseText?: string;
    withoutHeaderStyle?: boolean;
}

const DialogWarningSave: React.FC<DialogWarningSaveInterface> = ({
    positiveResponseText = 'Ja',
    negativeResponseText = 'Nee',
    ...props
}) => {
    const [dirty, setDirty] = useState(false);
    const classes = useStyles();
    const dialogHeaderStyle = props.withoutHeaderStyle ? '' : classes.dialogHeader;

    useEffect(() => {
        if (dirty) return;
        if (props.isLoading) setDirty(true);
    }, [dirty, props.isLoading]);

    useEffect(() => {
        if (dirty && !props.isLoading) props.onClose();
    }, [dirty, props]);

    return (
        <Dialog
            title={'Bevestig!'}
            onClose={props.onClose}
            style={{ zIndex: 99999999999 }}
            className={dialogHeaderStyle}
            autoFocus={true}
        >
            <p style={{ margin: '25px', textAlign: 'center', fontWeight: 'initial' }}>{props.message}</p>
            <DialogActionsBar>
                <button className="k-button" disabled={props.isLoading} onClick={props.operation}>
                    {props.isLoading ? <CircularProgress size={22} /> : positiveResponseText}
                </button>
                <button className="k-button" onClick={props.onClose}>
                    {negativeResponseText}
                </button>
            </DialogActionsBar>
        </Dialog>
    );
};

export default DialogWarningSave;
